/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTenantDto
 */
export interface CreateTenantDto {
    /**
     * AuthテナントID
     * @type {string}
     * @memberof CreateTenantDto
     */
    authTenantId: string;
    /**
     * テナント名
     * @type {string}
     * @memberof CreateTenantDto
     */
    name: string;
}

/**
 * Check if a given object implements the CreateTenantDto interface.
 */
export function instanceOfCreateTenantDto(value: object): value is CreateTenantDto {
    if (!('authTenantId' in value) || value['authTenantId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateTenantDtoFromJSON(json: any): CreateTenantDto {
    return CreateTenantDtoFromJSONTyped(json, false);
}

export function CreateTenantDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTenantDto {
    if (json == null) {
        return json;
    }
    return {
        
        'authTenantId': json['authTenantId'],
        'name': json['name'],
    };
}

export function CreateTenantDtoToJSON(json: any): CreateTenantDto {
    return CreateTenantDtoToJSONTyped(json, false);
}

export function CreateTenantDtoToJSONTyped(value?: CreateTenantDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'authTenantId': value['authTenantId'],
        'name': value['name'],
    };
}

